import { pnl_segments } from "../Constants/constants";

/**
 * [formatSegments Converts array to string and appends "&" to last element]
 * @param  {Array} userSegment
 *
 * @return {Element}
 */
export default function formatSegments(userSegment) {
  if (userSegment.length > 4) {
    return "All";
  } else {
    const formattedSegments = userSegment.map(
      (segment) => pnl_segments[segment]
    );
    let formattedText = "";
    if (formattedSegments.length === 1) {
      formattedText = formattedSegments[0];
    } else if (formattedSegments.length === 2) {
      formattedText = formattedSegments.join(" & ");
    } else if (formattedSegments.length > 2) {
      formattedText =
        formattedSegments.slice(0, -1).join(", ") +
        " & " +
        formattedSegments.slice(-1);
    }
    return formattedText;
  }
}
